import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import type { State } from './types.tsx';
import { SIDEBAR_MIN_WIDTH } from './constants.tsx';

export const localStorage = createLocalStorageProvider('jira_business_common');

export const getSidebarWidthFromStore = (store: State) => {
	if (store.sidebarWidth) {
		return store.sidebarWidth;
	}

	return SIDEBAR_MIN_WIDTH;
};
